import app from './app';
import token from './token';
import feedbackModal from './feedbackModal';
export default {
    app,
    token,
    feedbackModal
};



// WEBPACK FOOTER //
// ./src/reducers/rootReducer.js